import { FORM_ERROR } from 'final-form'

export const handleServerErrors = (e, options = {}) => {
  if (e.response && e.response.data && e.response.data.errors) {
    const errors = {}

    Object.keys(e.response.data.errors).forEach(field => {
      const outputField = options.remapFields && options.remapFields[field] ? options.remapFields[field] : field
      errors[outputField] = e.response.data.errors[field].map(error => error.message)
    })

    return errors
  }
  if (e.response && e.response.data && e.response.data.error) {
    return { [FORM_ERROR]: e.response.data.error.message }
  }
  else {
    return { [FORM_ERROR]: 'An error occured' }
  }
}

export const mapErrorCodes = e => {
  if (!e.response || !e.response.data) return []
  if (e.response.data.error) return [e.response.data.error.code]
  if (!e.response.data.errors) return []

  return Object.keys(e.response.data.errors).map(field =>
    e.response.data.errors[field].map(error => error.code)
  ).flat()
}

export const isInputWithError = meta => {
  return meta.touched && (meta.error || meta.submitError)
}

export const mergeValidations = formErrors => {
  const allErrors = {}

  formErrors.forEach(errors => {
    for (let field in errors) {
      if (allErrors[field]) {
        allErrors[field].forEach(error => {
          if (allErrors[field].indexOf(error) === -1) allErrors[field].push(error)
        })
      }
      else {
        allErrors[field] = errors[field]
      }
    }
  })

  return allErrors
}
